import { createTV } from 'tailwind-variants';

const FONT_SIZES = [
  'title-48',
  'title-36',
  'title-30',
  'title-24',
  'headline-20',
  'body-18',
  'body-16',
  'body-14',
  'body-13',
  'callout-16',
  'subhead-14',
  'caption-13',
  'caption-12',
  'caption-10',
];

const SHADOWS = ['card', 'modal'];

const ANIMATIONS = [
  'fade-in',
  'slide-in-right',
  'slide-in-left',
  'accordion-down',
  'accordion-up',
  'sheet-slide-up',
  'sheet-slide-down',
  'zoom-in',
  'attachment-progress',
  'skeleton-shimmer',
  'alert-in',
];

export const tv = createTV({
  twMergeConfig: {
    extend: {
      classGroups: {
        'font-size': [{ text: FONT_SIZES }],
        'shadow': [{ shadow: SHADOWS }],
        'animate': [{ animate: ANIMATIONS }],
      },
    },
  },
});
